export default "__VITE_ASSET__9RcSAHWW__"